import { render, staticRenderFns } from "./UpdateStatusesModal.vue?vue&type=template&id=10aeebc4&scoped=true"
import script from "./UpdateStatusesModal.vue?vue&type=script&lang=js"
export * from "./UpdateStatusesModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatusesModal.vue?vue&type=style&index=0&id=10aeebc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aeebc4",
  null
  
)

export default component.exports